import React, { useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import QrReader from "react-qr-reader";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ModalHeader from "react-bootstrap/ModalHeader";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const QRCodeScanner = ({
  show,
  onSubmit = () => {},
  onScan = () => {},
  onError = () => {},
  loading = false,
  onHide = () => {},
}) => {
  const { t } = useTranslation();
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    const mobile = data.get("mobile");
    onSubmit(mobile);
  };
  const handleScan = (data) => {
    if (data) {
      const result = JSON.parse(data);
      onScan(result);
    }
  };
  return (
    <Modal show={show} onHide={onHide}>
      <div className="qr-code-scanner-wrapper">
        <ModalHeader closeButton />
        <ModalBody className="modal-body">
          <h4>{t("qrCodeScanner.scan")}</h4>
          <div className="qr-code-reader-wrapper">
            <h4>{t("qrCodeScanner.enableAccess")}</h4>
            <QrReader
              className="qr-code-reader"
              showViewFinder={false}
              onScan={handleScan}
              onError={onError}
              delay={1000}
            />
          </div>
          {/* <br /> */}
          {/* <h4>{t("qrCodeScanner.or")}</h4> */}
          {/* <h4>{t("qrCodeScanner.inputMobile")}</h4> */}
          {/* <form onSubmit={handleSubmit}> */}
          {/*  <input type="text" name="mobile" /> */}
          {/*  <button type="submit" className="submit-btn"> */}
          {/*    {t("qrCodeScanner.submit")} */}
          {/*  </button> */}
          {/* </form> */}
        </ModalBody>
        {loading && (
          <>
            <div className="blurred-background" />
            <div className="flone-preloader">
              <span />
              <span />
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

QRCodeScanner.propTypes = {
  show: PropTypes.bool,
  onSubmit: PropTypes.func,
  onScan: PropTypes.func,
  onError: PropTypes.func,
  loading: PropTypes.bool,
  onHide: PropTypes.func,
};

function useLinkSellScanner() {
  const { t } = useTranslation();
  const history = useHistory();
  const cartData = useSelector((state) => state.cartData);

  const [isQRScannerOpen, setIsQRScannerOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});

  const onSingleProductScan = (data) => {
    const { token: customerToken = null, user = null } = data || {};

    if (!customerToken || !user) {
      window.alert(t("customerRedemption.invalidCode"));
      return;
    }

    history.push({
      pathname: "/checkout",
      state: { productID: selectedProduct._id, customerToken },
      // state: { productID: data._id },
    });
  };

  const onCartScan = (data) => {
    const { token: customerToken = null, user = null } = data || {};

    if (!customerToken || !user) {
      window.alert(t("customerRedemption.invalidCode"));
      return;
    }

    history.push({
      pathname: "/checkout",
      state: { cartID: cartData._id, customerToken },
    });
  };

  return {
    isQRScannerOpen,
    setIsQRScannerOpen,
    setSelectedProduct,
    onSingleProductScan,
    onCartScan,
  };
}

export { useLinkSellScanner };
export default QRCodeScanner;
